import { render, staticRenderFns } from "./SidebarLinkGroup.vue?vue&type=template&id=615358e0&scoped=true&"
import script from "./SidebarLinkGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarLinkGroup.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLinkGroup.vue?vue&type=style&index=0&id=615358e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615358e0",
  null
  
)

export default component.exports